<template>
    <VJoyWrapper no-margin row-gap="2" column-gap="2" align="center">
        <span class="profile-name">{{ firstName }} {{ lastNameNormalized }}</span>
        <ProfileStrategyBadge v-if="vertical === 'STRATEGY'" />
        <ProfileBadge :first-name="firstName" :badges="badges" />
        <slot />
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {VJoyWrapper} from '@maltjoy/core-vue';
    import ProfileBadge from './ProfileBadge.vue';
    import ProfileStrategyBadge from './ProfileStrategyBadge.vue';
    import type {ProfileBadgeEnum, ProfileVertical} from '../types';

    interface ProfileNameProps {
        firstName: string;
        lastNameNormalized: string;
        badges: ProfileBadgeEnum[];
        vertical?: ProfileVertical;
    }

    const props = defineProps<ProfileNameProps>();
</script>

<style scoped lang="scss">
    .profile-name {
        font-weight: var(--joy-font-weight-bold);
        font-size: var(--joy-font-size-primary-400);
        line-height: var(--joy-line-height-large);
        color: var(--joy-color-primary-50);
        margin: 0;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
